module.exports = __webpack_public_path__ + "static/img/0541_9.e278736.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/0541_9.jpg
// module id = JMnH
// module chunks = 1